export const createToast = ( message: string, timeout: number = 3000 ): HTMLElement => {
	let container = document.querySelector<HTMLElement>('.toast-container');

	if (!container) {
		container = document.createElement('div');
		container.classList.add('toast-container');
		container.setAttribute('aria-live', 'polite');
		container.setAttribute('aria-atomic', 'false');
		document.body.appendChild(container);
	}

	const el = document.createElement('div');
	el.classList.add('toast');
	el.setAttribute('role', 'status');
	el.setAttribute('aria-atomic', 'true');
	el.textContent = message;
	container.appendChild(el);

	window.requestAnimationFrame(() => {
		el.classList.add('toast--visible');
	});

	window.setTimeout(() => {
		el.classList.remove('toast--visible');

		window.setTimeout(() => {
			el.remove();

			if (container && !container.childElementCount) {
				container.remove();
			}
		}, 250);
	}, timeout);

	return el;
};
